import type { GetRemainSeconds } from './types';

export const getRemainSeconds: GetRemainSeconds = (targetTimestamp) => {
  const currentTimestamp = Date.now();

  return currentTimestamp <= targetTimestamp
    ? Math.ceil((targetTimestamp - currentTimestamp) / 1000)
    : 0;
};
